import React, { useState } from 'react';
import { Hero } from '../components/Hero';
import { ValueProposition } from '../components/ValueProposition';
import { PricingPlans } from '../components/PricingPlans';
import { AddOns } from '../components/AddOns';
import { AdvancedAutomation } from '../components/AdvancedAutomation';
import { Button } from '../components/Button';
import { StarIcon, QuoteIcon, ChevronDownIcon } from 'lucide-react';
function FeatureShowcase() {
  return <section className="w-full bg-[#1A1A1A] py-28 md:py-36" data-id="element-1444">
      <div className="max-w-7xl mx-auto px-8 md:px-12" data-id="element-1445">
        {/* Feature 1 - Left Image */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-32" data-id="element-1446">
          <div className="relative" data-id="element-1447">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden border border-[#2A2A2A] shadow-2xl" data-id="element-1448">
              <img src="https://images.unsplash.com/photo-1551434678-e076c223a692?w=1200&q=80" alt="Real-time dashboard analytics" className="w-full h-full object-cover" data-id="element-1449" />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-[#F1B530] rounded-2xl p-6 shadow-xl" data-id="element-1450">
              <div className="font-['Poppins'] text-4xl font-bold text-[#0F0F0F] mb-1" data-id="element-1451">
                100%
              </div>
              <div className="font-['Inter'] text-sm text-[#0F0F0F] font-semibold" data-id="element-1452">
                Capture Rate
              </div>
            </div>
          </div>

          <div data-id="element-1453">
            <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl text-[#F5F5F5] mb-6" data-id="element-1454">
              Real-Time Dashboard & Analytics
            </h2>
            <p className="font-['Inter'] text-lg text-[#A0A0A0] mb-8 leading-relaxed font-light" data-id="element-1455">
              Monitor every call in real-time with comprehensive analytics.
              Track call volume, response times, customer satisfaction, and
              conversion rates all in one intuitive dashboard.
            </p>
            <ul className="space-y-4 mb-8" data-id="element-1456">
              <li className="flex items-start" data-id="element-1457">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-1458">•</span>
                <span className="font-['Inter'] text-[#F5F5F5] font-light" data-id="element-1459">
                  Live call monitoring and notifications
                </span>
              </li>
              <li className="flex items-start" data-id="element-1460">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-1461">•</span>
                <span className="font-['Inter'] text-[#F5F5F5] font-light" data-id="element-1462">
                  Detailed call transcripts and recordings
                </span>
              </li>
              <li className="flex items-start" data-id="element-1463">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-1464">•</span>
                <span className="font-['Inter'] text-[#F5F5F5] font-light" data-id="element-1465">
                  Performance metrics and insights
                </span>
              </li>
            </ul>
            <Button data-id="element-1466">Explore Dashboard</Button>
          </div>
        </div>

        {/* Feature 2 - Right Image */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-32" data-id="element-1467">
          <div className="lg:order-2 relative" data-id="element-1468">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden border border-[#2A2A2A] shadow-2xl" data-id="element-1469">
              <img src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=1200&q=80" alt="Seamless integrations" className="w-full h-full object-cover" data-id="element-1470" />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-[#252525] border border-[#F1B530] rounded-2xl p-6 shadow-xl" data-id="element-1471">
              <div className="font-['Poppins'] text-4xl font-bold text-[#F1B530] mb-1" data-id="element-1472">
                50+
              </div>
              <div className="font-['Inter'] text-sm text-[#F5F5F5] font-semibold" data-id="element-1473">
                Integrations
              </div>
            </div>
          </div>

          <div className="lg:order-1" data-id="element-1474">
            <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl text-[#F5F5F5] mb-6" data-id="element-1475">
              Seamless CRM & Tool Integration
            </h2>
            <p className="font-['Inter'] text-lg text-[#A0A0A0] mb-8 leading-relaxed font-light" data-id="element-1476">
              Connect with your existing tools effortlessly. Our AI integrates
              with popular CRMs, calendars, and business tools to keep your
              workflow smooth and data synchronized.
            </p>
            <ul className="space-y-4 mb-8" data-id="element-1477">
              <li className="flex items-start" data-id="element-1478">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-1479">•</span>
                <span className="font-['Inter'] text-[#F5F5F5] font-light" data-id="element-1480">
                  Salesforce, HubSpot, Zoho CRM
                </span>
              </li>
              <li className="flex items-start" data-id="element-1481">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-1482">•</span>
                <span className="font-['Inter'] text-[#F5F5F5] font-light" data-id="element-1483">
                  Google Calendar, Outlook, Calendly
                </span>
              </li>
              <li className="flex items-start" data-id="element-1484">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-1485">•</span>
                <span className="font-['Inter'] text-[#F5F5F5] font-light" data-id="element-1486">
                  Slack, Teams, Zapier, and more
                </span>
              </li>
            </ul>
            <Button data-id="element-1487">View All Integrations</Button>
          </div>
        </div>

        {/* Feature 3 - Left Image */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-1488">
          <div className="relative" data-id="element-1489">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden border border-[#2A2A2A] shadow-2xl" data-id="element-1490">
              <img src="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=1200&q=80" alt="AI training and customization" className="w-full h-full object-cover" data-id="element-1491" />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-[#252525] border border-[#F1B530] rounded-2xl p-6 shadow-xl" data-id="element-1492">
              <div className="font-['Poppins'] text-4xl font-bold text-[#F1B530] mb-1" data-id="element-1493">
                &lt;5min
              </div>
              <div className="font-['Inter'] text-sm text-[#F5F5F5] font-semibold" data-id="element-1494">
                Setup Time
              </div>
            </div>
          </div>

          <div data-id="element-1495">
            <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl text-[#F5F5F5] mb-6" data-id="element-1496">
              Custom AI Training for Your Business
            </h2>
            <p className="font-['Inter'] text-lg text-[#A0A0A0] mb-8 leading-relaxed font-light" data-id="element-1497">
              Train your AI receptionist with your business knowledge, FAQs, and
              specific protocols. The more you customize, the more natural and
              helpful your AI becomes.
            </p>
            <ul className="space-y-4 mb-8" data-id="element-1498">
              <li className="flex items-start" data-id="element-1499">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-1500">•</span>
                <span className="font-['Inter'] text-[#F5F5F5] font-light" data-id="element-1501">
                  Upload FAQs and knowledge base
                </span>
              </li>
              <li className="flex items-start" data-id="element-1502">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-1503">•</span>
                <span className="font-['Inter'] text-[#F5F5F5] font-light" data-id="element-1504">
                  Define custom call routing rules
                </span>
              </li>
              <li className="flex items-start" data-id="element-1505">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-1506">•</span>
                <span className="font-['Inter'] text-[#F5F5F5] font-light" data-id="element-1507">
                  Set brand voice and tone guidelines
                </span>
              </li>
            </ul>
            <Button data-id="element-1508">Start Customizing</Button>
          </div>
        </div>
      </div>
    </section>;
}
function Testimonials() {
  const testimonials = [{
    quote: "This AI answering service has transformed how we handle customer calls. We've seen a 40% increase in captured leads since implementing it.",
    author: 'Sarah Mitchell',
    role: 'CEO, TechStart Solutions',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&q=80',
    rating: 5
  }, {
    quote: 'The 24/7 coverage means we never miss an opportunity. Our customers love the instant response, and so do we.',
    author: 'James Chen',
    role: 'Operations Director, GrowthCo',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&q=80',
    rating: 5
  }, {
    quote: "Setup was incredibly easy, and the AI sounds so natural. It's like having a professional receptionist without the overhead costs.",
    author: 'Emma Thompson',
    role: 'Founder, Bright Ideas Agency',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&q=80',
    rating: 5
  }];
  return <section className="w-full bg-[#0F0F0F] py-28 md:py-36" data-id="element-1509">
      <div className="max-w-7xl mx-auto px-8 md:px-12" data-id="element-1510">
        <div className="text-center mb-20" data-id="element-1511">
          <h2 className="font-['Poppins'] font-bold text-5xl md:text-6xl text-[#F5F5F5] mb-6" data-id="element-1512">
            Trusted by Growing Businesses
          </h2>
          <p className="font-['Inter'] text-xl text-[#A0A0A0] font-light" data-id="element-1513">
            See what our customers have to say
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1514">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-[#252525] border border-[#2A2A2A] rounded-2xl p-8 hover:border-[#F1B530]/30 transition-all duration-300" data-id="element-1515">
              <div className="flex gap-1 mb-6" data-id="element-1516">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-[#F1B530] fill-current" data-id="element-1517" />)}
              </div>

              <QuoteIcon className="w-10 h-10 text-[#F1B530]/20 mb-4" data-id="element-1518" />

              <p className="font-['Inter'] text-[#F5F5F5] mb-8 leading-relaxed font-light" data-id="element-1519">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-4" data-id="element-1520">
                <img src={testimonial.image} alt={testimonial.author} className="w-12 h-12 rounded-full object-cover border-2 border-[#F1B530]/20" data-id="element-1521" />
                <div data-id="element-1522">
                  <div className="font-['Inter'] font-semibold text-[#F5F5F5]" data-id="element-1523">
                    {testimonial.author}
                  </div>
                  <div className="font-['Inter'] text-sm text-[#A0A0A0]" data-id="element-1524">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
function IndustryBenefits() {
  const industries = [{
    name: 'Healthcare',
    benefits: ['HIPAA compliant', 'Appointment scheduling', 'Emergency routing', 'Patient messaging']
  }, {
    name: 'Legal',
    benefits: ['Client intake', 'Confidential handling', 'Urgent call screening', 'Case management']
  }, {
    name: 'Real Estate',
    benefits: ['Property inquiries', 'Viewing bookings', 'Lead capture', 'Tenant support']
  }, {
    name: 'Trade Services',
    benefits: ['Job booking', 'Emergency calls', 'Quote requests', 'Service scheduling']
  }, {
    name: 'Retail',
    benefits: ['Order taking', 'Store inquiries', 'Stock checks', 'Customer support']
  }, {
    name: 'Professional Services',
    benefits: ['Client screening', 'Appointment booking', 'Message handling', 'Consultation scheduling']
  }];
  return <section className="w-full bg-[#1A1A1A] py-28" data-id="element-1525">
      <div className="max-w-7xl mx-auto px-8 md:px-12" data-id="element-1526">
        <div className="text-center mb-16" data-id="element-1527">
          <h2 className="font-['Poppins'] font-bold text-5xl md:text-6xl text-[#F5F5F5] mb-6" data-id="element-1528">
            Trusted Across Industries
          </h2>
          <p className="font-['Inter'] text-xl text-[#A0A0A0] font-light" data-id="element-1529">
            Tailored solutions for every business type
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1530">
          {industries.map((industry, index) => <div key={index} className="bg-[#252525] border border-[#2A2A2A] rounded-2xl p-8 hover:border-[#F1B530]/30 transition-all duration-300" data-id="element-1531">
              <h3 className="font-['Poppins'] font-bold text-2xl text-[#F5F5F5] mb-6" data-id="element-1532">
                {industry.name}
              </h3>
              <ul className="space-y-3" data-id="element-1533">
                {industry.benefits.map((benefit, idx) => <li key={idx} className="font-['Inter'] text-[#A0A0A0] flex items-start" data-id="element-1534">
                    <span className="text-[#F1B530] mr-2" data-id="element-1535">•</span>
                    {benefit}
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
}
function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'How does the AI answering service work?',
    answer: 'Our AI receptionist answers calls 24/7, captures caller information, handles FAQs, and can even book appointments. It integrates seamlessly with your existing systems and can be customized to match your business needs.'
  }, {
    question: 'Can I customize the greeting and responses?',
    answer: 'Absolutely! You can fully customize your company greeting, upload FAQs, set routing rules, and define your brand voice. The AI learns from your business to provide accurate, on-brand responses.'
  }, {
    question: "What happens if the AI can't handle a call?",
    answer: 'The AI can transfer calls to your team with full context when needed. You set the rules for when calls should be escalated, ensuring important matters always reach the right person.'
  }, {
    question: 'How quickly can I get started?',
    answer: "Setup takes less than 5 minutes. Simply sign up, customize your greeting and settings, forward your number, and you're live. We provide step-by-step guidance throughout the process."
  }, {
    question: 'Is there a contract or commitment?',
    answer: 'No long-term contracts required. Start with our 7-day free trial, then choose a monthly plan that fits your needs. You can upgrade, downgrade, or cancel anytime.'
  }];
  return <section className="w-full bg-[#1A1A1A] py-28 md:py-36" data-id="element-1536">
      <div className="max-w-4xl mx-auto px-8 md:px-12" data-id="element-1537">
        <div className="text-center mb-16" data-id="element-1538">
          <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl text-[#F5F5F5] mb-6" data-id="element-1539">
            Frequently Asked Questions
          </h2>
          <p className="font-['Inter'] text-lg text-[#A0A0A0] font-light" data-id="element-1540">
            Everything you need to know about our AI answering service
          </p>
        </div>

        <div className="space-y-4" data-id="element-1541">
          {faqs.map((faq, index) => <div key={index} className="bg-[#252525] border border-[#2A2A2A] rounded-2xl overflow-hidden transition-all duration-300 hover:border-[#F1B530]/30" data-id="element-1542">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-8 py-6 flex items-center justify-between text-left" data-id="element-1543">
                <span className="font-['Inter'] font-semibold text-xl text-[#F5F5F5] pr-8" data-id="element-1544">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-[#F1B530] flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-1545" />
              </button>

              <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`} data-id="element-1546">
                <div className="px-8 pb-6" data-id="element-1547">
                  <p className="font-['Inter'] text-[#A0A0A0] leading-relaxed font-light" data-id="element-1548">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
export function LandingPage() {
  return <div className="w-full min-h-screen" data-id="element-1549">
      <Hero data-id="element-1550" />
      <ValueProposition data-id="element-1551" />
      <FeatureShowcase data-id="element-1552" />
      <IndustryBenefits data-id="element-1553" />
      <PricingPlans data-id="element-1554" />
      <Testimonials data-id="element-1555" />
      <AddOns data-id="element-1556" />
      <AdvancedAutomation data-id="element-1557" />
      <FAQ data-id="element-1558" />
    </div>;
}